export default __webpack_public_path__ + "a3df25146f33d1adfabc0a74505e95b9.svg";